module.exports = __webpack_public_path__ + "img/aw-10@2x.png";